const handleMobileSelect = onChangeCallback => {
  const selectElement = $(".js-formats-native-dropdown-wrapper select");
  selectElement.each(function() {
    const selectWrapper = $(this).parent();
    const selectBody = selectWrapper.find(".formats-native-dropdown__body");

    if ($(this).length) {
      selectBody.text($(this)[0].options[$(this)[0].selectedIndex].text);

      $(this).on("click keydown", function(e) {
        const { type, keyCode } = e;
        e.stopPropagation();

        if (type === "click") {
          selectWrapper.addClass("is-active");
        }
        if (type === "keydown") {
          if (keyCode === 32) {
            selectWrapper.addClass("is-active");
          }
        }
      });

      $(this).on("focus", function() {
        selectWrapper.addClass("is-focus");
      });

      $(this).on("change", function() {
        selectBody.text($(this)[0].options[$(this)[0].selectedIndex].text);
        selectWrapper.removeClass("is-active");
        onChangeCallback($(this));
      });

      $(this).on("blur", function() {
        selectWrapper.removeClass("is-active is-focus");
      });
    }
  });
};

const handleCloseSelects = () => {
  const selectElement = $(".js-mobile-select-wrapper select");
  const selectWrapper = selectElement.parent();

  $("body").on("click", function(e) {
    const target = $(e.target);

    if (!target.closest(".js-mobile-select-wrapper select").length) {
      selectWrapper.removeClass("is-active");
    }

    if (!target.closest(".formats-dropdown").length) {
      $(".js-formats-dropdown-action")
        .parent(".formats-dropdown")
        .removeClass("is-active");
    }
  });
};

export const initMobileFormatsSelect = (onChangeCallback = () => false) => {
  handleMobileSelect(onChangeCallback);
  handleCloseSelects();
};
